"use strict";
(self["webpackChunkpop_and_bottle"] = self["webpackChunkpop_and_bottle"] || []).push([[783],{

/***/ 783:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ productPrice)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utilities_functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(363);



// https://help.shopify.com/en/manual/payments/currency-formatting#currency-formatting-options
function productPrice({ wrapper }) {
  const cache = {
    $price: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-hook="product-price"]'),
    $comparePrice: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-hook="product-compare-at-price"]'),
    $form: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).parents('form[action="/cart/add"]'),
  }

  const classes = {
    hidden: 'hidden',
  }

  const format = '${{ amount }}';

  ; (function init() {
    cache.$form.on('variant-selector:change', update)
  })()

  function update(event, { variant }) {
    updatePrice(variant)
    updateComparePrice(variant)
  }

  function updatePrice(variant) {
    if (!variant.price || cache.$price.length < 1) return

    let price = (0,_utilities_functions__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variant.price, format)

    cache.$price.text(price)
  }

  function updateComparePrice(variant) {
    if (cache.$comparePrice.length < 1) return

    cache.$comparePrice.toggleClass(classes.hidden, !variant.compare_at_price)
    // if no compare price, hide the element
    if (!variant.compare_at_price) {
      cache.$comparePrice.text('')
      return
    }

    const price = (0,_utilities_functions__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variant.compare_at_price, format)
    cache.$comparePrice.text(price)
  }
}


/***/ })

}]);